import api from './data.services'
import { authService } from '.'

const preferentialSrv = 'preferreds/patients'

const getCurrent = async () => {
  try {
    const resp: any = await api.get(`${preferentialSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data.preferreds ? resp.data.preferreds : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener citas médicas!'
    }
  }
}

export const preferentialService = {
  getCurrent
}